import { render, staticRenderFns } from "./SellDetails.vue?vue&type=template&id=0e8b9bc4"
import script from "./SellDetails.ts?vue&type=script&lang=js&external"
export * from "./SellDetails.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports